


















































import BtnList from 'library/components/globals/btn-list'
import { mountOnBody } from 'library/services/helpers'
import VideoModal from 'library/components/globals/modals/video'
import NewsletterSignup from 'library/components/globals/newsletter-signup'

export default

	props: block: Object

	components: {
		BtnList
		NewsletterSignup
	}

	computed:
		classes: -> [
			"height-#{@block.height}" # short, medium, or tall
			'split' if @bkgdLeft
			"content-bg-#{@contentBg}"
			"layout-#{@block.layout}"
			@hasImages
		]

		videoClasses: -> [
			"position-#{@block.videoPosition}"
		]

		styles: ->
			backgroundColor: @block.backgroundColor if @block.backgroundColor

		img: -> if @block.imageFull? then return @block.imageFull[0]
		imgLeft: -> if @block.imageLeft?.length then return @block.imageLeft
		imgRight: -> if @block.imageRight?.length then return @block.imageRight

		# computed property to quickly access wether
		# the marquee has images or not
		hasImages: ->
			if !@isFullImg && !@imgLeft && !@imgRight && !@hasVideo then return 'no-assets'
			else return 'has-assets'

		isFullImg: ->
			if @img?.portrait?.length > 0 || @img?.landscape?.length > 0 then return true
			else return false

		hasVideo: ->
			if @block.videoBkgd?.length > 0 then return true
			else return false

		# default to white content bg
		contentBg: ->
			if @block.marqueeColorBackground == 'white' || !@block.marqueeColorBackground
				return 'white'
			else return ''

		# set a unique ID based on the block to pass to the newsletter form
		uniqueFormId: -> "newsletter-#{@block.id}"

	methods:
		onClick: (e) ->

			# first, mount video if selected
			if @block.videoModal
				e.preventDefault()
				@mountVideoModal()

			# Prevent clicking if non-interactive
			if @nonInteractive
			then e.preventDefault()
			else @$emit 'click'

		mountVideoModal: ->
			await mountOnBody VideoModal,
				parent: this
				propsData: { videoUrl: @block.videoModal }

